import { RecolorModule } from '@seddi/ui-recolor';
import { GarmentGeometryModule } from './garmentGeometry/garmentGeometryModule';

/**
 * Initialize lib.
 */
export const initializeLib = async (): Promise<void> => {
  await Promise.all([GarmentGeometryModule.init(), RecolorModule.init()]);
};
